import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=0dcee146&scoped=true&"
import script from "./SearchCard.vue?vue&type=script&lang=js&"
export * from "./SearchCard.vue?vue&type=script&lang=js&"
import style0 from "./SearchCard.vue?vue&type=style&index=0&id=0dcee146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcee146",
  null
  
)

export default component.exports